import { render } from "./AdminRootDashboardItem.vue?vue&type=template&id=d819705e&scoped=true"
import script from "./AdminRootDashboardItem.vue?vue&type=script&lang=js"
export * from "./AdminRootDashboardItem.vue?vue&type=script&lang=js"

import "./AdminRootDashboardItem.vue?vue&type=style&index=0&id=d819705e&scoped=true&lang=css"

import exportComponent from "X:\\GRV\\CPS5\\Projetos\\CPSDashApontamento\\WebDashBoard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d819705e"]])

export default __exports__